import {
    GET_CARTNUMS,
    SAVE_MEMBERINFO,
    SAVE_USERINFO,
    CHANGE_WALLET_STATE,
    SAVE_REGISTER_RESULT,
    SAVE_COMPANYCODE,
    SAVE_MONEY,
    SAVE_ORDER,
    SAVE_ONCE_PAYMENT_PRICE,
    SAVE_MONEYINFO,
    TABREMEMBER,
    SAVE_BANKINFO,
    GET_AREALIST,
    GET_BANK,
    GET_SEARCH_BANK_LIST,
    GET_MY_BANK,
    GET_ASSETS_USER_INFO,
    GET_BANKCARD_WITHDRAW_LIST,
    GET_BANKCARD_CASHIERDESK,
    GET_OPEN_ACCOUNT_INFO,
    PAGE_ENTER_TIME,
    GET_ADDRESS_INFO,
    GET_ADDRESSLIST_INFO,
    GET_PICLIST_INFO,
    GET_COUPON_INFO,
    GET_COUPON_STATUS
} from './const.js'
export default {
    [GET_CARTNUMS] (state, cartNums) {
        state.cartNum = cartNums
    },
    [SAVE_MEMBERINFO] (state, memberInfo) {
        state.memberInfo = memberInfo
    },
    [SAVE_USERINFO] (state, userInfo) {
        state.userInfo = userInfo
    },
    [CHANGE_WALLET_STATE] (state, walletState) {
        state.walletState = walletState
    },
    [SAVE_REGISTER_RESULT] (state, result) {
        state.result = result
    },
    [SAVE_COMPANYCODE] (state, companyCode) {
        state.companyCode = companyCode
    },
    [SAVE_MONEY] (state, money) {
        state.money = money
    },
    [SAVE_ORDER] (state, orderDetail) {
        state.orderDetail = orderDetail
    },
    [SAVE_ONCE_PAYMENT_PRICE] (state, paymentAmount) {
        state.paymentAmount = paymentAmount
    },
    [SAVE_MONEYINFO] (state, moneyInfo) {
        state.moneyInfo = moneyInfo
    },
    [TABREMEMBER] (state, payload) {
        state.tabRemember = payload
    },
    [SAVE_BANKINFO] (state, payload) {
        state.bankInfo = payload
    },
    [GET_AREALIST] (state, payload) {
        state.areaList = payload
    },
    [GET_BANK] (state, payload) {
        state.bankData = payload
    },
    [GET_SEARCH_BANK_LIST] (state, payload) {
        state.bankSearchList = payload
    },
    [GET_MY_BANK] (state, payload) {
        state.myBankList = payload
    },
    [GET_ASSETS_USER_INFO] (state, payload) {
        state.assetsUserInfo = payload
    },
    [GET_BANKCARD_WITHDRAW_LIST] (state, payload) {
        state.bankcardWithdrawList = payload
    },
    [GET_BANKCARD_CASHIERDESK] (state, payload) {
        state.cashierdesk = payload
    },
    [GET_OPEN_ACCOUNT_INFO] (state, payload) {
        state.openAccountInfo = payload
    },
    [PAGE_ENTER_TIME] (state, payload) {
        state.pageEnterTime = payload
    },
    [GET_ADDRESS_INFO] (state, payload) {
        state.addressList = payload
    },
    [GET_ADDRESSLIST_INFO] (state, payload) {
        state.addressInfo = payload
    },
    [GET_PICLIST_INFO] (state, payload) {
        state.picList = payload
    },
    [GET_COUPON_INFO] (state, payload) {
        state.couponInfo = payload
    },
    [GET_COUPON_STATUS] (state, payload) {
        state.couponStatus = payload
    }
}